import script from "./RenewalBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./RenewalBanner.vue?vue&type=script&setup=true&lang=js"

import "./RenewalBanner.vue?vue&type=style&index=0&id=5acb830a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5acb830a"]])

export default __exports__